export const environment = {
  production: false,
  baseUrl: "https://api.latest.wizefulfill.com/",
  sellerCloudUrl: "https://shtiks.api.sellercloud.com/rest/api/",
  authServiceUrl: "https://api.latest.wizefulfill.com/auth_service",
  clientServiceUrl: "https://api.latest.wizefulfill.com/client_service",
  spServiceUrl: "https://api.latest.wizefulfill.com/wms_service",
  chatbotUrl: "https://stage.bot.wizefulfill.com/",

  // authServiceUrl: 'http://localhost:8000',
  // clientServiceUrl: 'http://localhost:8001',
  // spServiceUrl: 'http://localhost:8002',
};
